import { axios, Response } from '..'
export interface ChangeTaskStatusRequest {
  newTaskStatus: string
}

export const editTaskStatus = (
  taskId: string,
  request: ChangeTaskStatusRequest
): Response<void> => {
  return axios.put(`/v1/tasks/${taskId}/status`, request, {})
}
